import React, { useEffect } from "react";
import { Result, Layout } from "antd";
import PainelAtividades from "../Pages/PainelAtividades";
import MeusPacientes from "../Pages/MeusPacientes";
import Adesao from "../Pages/Adesao";
import Login from "../Components/Login";
import { Route, Routes as RouterRoutes, Link } from "react-router-dom";
import BoasVindas from "Pages/BoasVindas";
import Rotina from "Pages/Rotina";
import Urgencia from "Pages/Urgencia";
import AtendimentoSolicitado from "Pages/AtendimentoSolicitado";
import MedicoesIncomuns from "Pages/MedicoesIncomuns";
import Ausencia from "Pages/Ausencia";
import Pacientes from "Pages/Pacientes";
import Dashboard from "Pages/Dashboard";
import Home from "Pages/Home";
import Atendentes from "Pages/Atendentes";
import ProcessosInflamatorios from "Pages/ProcessosInflamatorios";
import SideBar from "Components/SideBar";
import HeaderBackoffice from "Components/Header";
import { connect } from "react-redux";
import * as loginActions from "Components/Login/action";
import BarLoader from "react-spinners/BarLoader";
import logo from "Assets/Images/logo.png";
import { isAdmin } from "Misc/utils";
import { PERFIS } from "Misc/constants";
import DesvioPadrao from "Pages/DesvioPadrao";

const { Header, Content } = Layout;

const Routes = ({ user, saveUser, logOut }) => {
  useEffect(() => {
    if (localStorage.getItem("user")) {
      const token = localStorage.getItem("user");
      saveUser(token);
    } else {
      console.info("Faça login novamente!");
      logOut();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  switch (user) {
    case undefined:
      return <LogoPage />;
    case false:
      return (
        <RouterRoutes>
          <Route path="*" element={<TitleRoute title="Entrar no Sistema - Viver360"><Login /></TitleRoute>} />
        </RouterRoutes>
      );
    default:
      return (
        <>
          <SideBar />
          <Layout className="layout">
            <Header className="layout-header">
              <HeaderBackoffice />
            </Header>

            <Content className="layout-content">
              <RouterRoutes>
                <Route path="/" element={<TitleRoute title="Home - Viver360"><Home /></TitleRoute>} />
                {user?.perfil !== PERFIS.ADMIN_VIVER && (
                  <Route path="/painel" element={<TitleRoute title="Painel de Atendimento - Viver360"><PainelAtividades /></TitleRoute>} />
                )}
                {user?.perfil !== PERFIS.ADMIN_VIVER && (
                  <Route path="/meuspacientes" element={<TitleRoute title="Plano de Cuidados - Viver360"><MeusPacientes /></TitleRoute>} />
                )}
                {user?.perfil === PERFIS.ADMIN_VIVER && (
                  <Route path="/equipesaude" element={<PrivateTitleRoute perfil={user?.perfil} pageName="Painel" pageRedirect="/painel" title="Equipe de Saúde - Viver360"><Atendentes /></PrivateTitleRoute>} />
                )}
                <Route path="/pacientes/:idPaciente?" element={<TitleRoute title="Pacientes - Viver360"><Pacientes /></TitleRoute>} />
                <Route path="/dashboard/:tipo?/:filtro?" element={<PrivateTitleRoute perfil={user?.perfil} pageName="Painel" pageRedirect="/painel" title="Dashboard - Viver360"><Dashboard /></PrivateTitleRoute>} />
                <Route path="/adesao/:tipo?/:tarefa?/" element={<TitleRoute title="Adesão - Viver360"><Adesao /></TitleRoute>} />
                <Route path="/boasvindas/:tipo?/:tarefa?/" element={<TitleRoute title="Boas Vindas - Viver360"><BoasVindas /></TitleRoute>} />
                <Route path="/rotina/:tipo?/:tarefa?/" element={<TitleRoute title="Ligação de Rotina - Viver360"><Rotina /></TitleRoute>} />
                <Route path="/urgencia/:tipo?/:tarefa?/" element={<TitleRoute title="Urgência Médica - Viver360"><Urgencia /></TitleRoute>} />
                <Route path="/ausencia/:tipo?/:tarefa?/" element={<TitleRoute title="Ausencia de Reporte - Viver360"><Ausencia /></TitleRoute>} />
                <Route path="/atendimento/:tipo?/:tarefa?/" element={<TitleRoute title="Atendimento Solicitado - Viver360"><AtendimentoSolicitado /></TitleRoute>} />
                <Route path="/desvio-padrao/:tipo?/:tarefa?/" element={<TitleRoute title="Desvio Padrão - Viver360"><DesvioPadrao /></TitleRoute>} />
                <Route path="/medicoes-incomuns/:tipo?/:tarefa?/" element={<TitleRoute title="Medições incomuns - Viver360"><MedicoesIncomuns /></TitleRoute>} />
                <Route path="/sintomas-inflamatorios/:tipo?/:tarefa?/" element={<TitleRoute title="Sintomas inflamatórios - Viver360"><ProcessosInflamatorios /></TitleRoute>} />
                <Route path="/reativacao/:tipo?/:tarefa?/" element={<TitleRoute title="Reativar Monitoramento - Viver360"><BoasVindas /></TitleRoute>} />
                <Route path="*" element={<TitleRoute title="Ops, não encontramos essa página - Viver360"><Result status="404" title="404" subTitle="Ops, não encontramos essa página." extra={<Link to="/">Voltar para Home</Link>} /></TitleRoute>} />
              </RouterRoutes>
            </Content>
          </Layout>
        </>
      );
  }
};

const LogoPage = (props) => (
  <div className="logo-page">
    <img src={logo} alt="Logo da Viver360 Care Platform" width={450} />
    <BarLoader color={"#0F79B2"} width={400} />
  </div>
);

const TitleRoute = ({ children, title = "Viver360 Care Platform" }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return <>{children}</>;
};

const PrivateTitleRoute = ({ perfil, children, title = "Viver360 Care Platform", pageRedirect = "/", pageName = "Home" }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
  if (isAdmin(perfil)) {
    return <>{children}</>;
  }
  return (
    <Result
      status="403"
      title="Acesso negado"
      subTitle="Desculpe, você não tem acesso a esta página. Qualquer dúvida entrar em contato com o Administrador."
      extra={<Link to={pageRedirect}>Voltar para {pageName}</Link>}
    />
  );
};

const mapStateToProps = (store) => ({
  user: store.login.user,
});

const mapDispatchToProps = (dispatch) => ({
  logOut: () => dispatch(loginActions.logOut()),
  saveUser: (token) => dispatch(loginActions.saveUser(token)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
